export const list = {
  table: {
    id: 'ID',
    name: '名前',
    price: '価格',
    total: '合計',
    quantity: '仕入れ数量(ケース)',
    bin: 'ケース',
    updatedAt: '仕入れ日',
  },
  pageHeader: {
    detergentTitle: '洗剤リスト　洗剤情報編集画面',
    title: '在庫履歴',
    titleDetergentsList: '個人データ登録/編集',
    new: '新規',
  },
}
